interface CookieModel {
  deviceCheck: boolean;
}

export const getCookieValue = <T extends keyof CookieModel>(
  name: T,
): CookieModel[T] | null => {
  const item = document.cookie
    .split("; ")
    .find((c) => c.startsWith(name + "="))
    ?.split("=")[1];
  if (item) {
    return JSON.parse(item);
  } else {
    return null;
  }
};

export const setCookie = <T extends keyof CookieModel>(
  name: T,
  value: CookieModel[T],
  options: { allSubdomains?: boolean; expiresInDays?: number },
): void => {
  let expires: string = "";
  let domain = "";
  let sameSite = "";
  if (options.expiresInDays) {
    const expiryDate = new Date();
    expiryDate.setTime(
      expiryDate.getTime() + options.expiresInDays * 24 * 60 * 60 * 1000,
    );
    expires = `expires=${expiryDate.toUTCString()};`;
  }
  if (options.allSubdomains) {
    domain = "domain=.schiri-bayern.de;";
    sameSite = "SameSite=Lax;";
  }
  document.cookie = `${name}=${value}; path=/; ${expires} ${domain} Secure; ${sameSite}`;
};
